/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { ChevronDownIcon, ChevronUpIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/video-logged-out-page';

type Props = { collapsed: boolean };

const ToggleButton: React.FC<Props> = ({ collapsed }) => {
  if (collapsed) {
    return (
      <Button
        data-unit="show-more"
        className="more-btn"
        variant="ghost"
        icon={<ChevronDownIcon />}
        iconPosition="before"
      >
        {_t('More')}
      </Button>
    );
  }
  return (
    <Button data-unit="show-less" className="more-btn" variant="ghost" icon={<ChevronUpIcon />} iconPosition="before">
      {_t('Show less')}
    </Button>
  );
};

export default ToggleButton;
